const apiHost = process.env.REACT_APP_API_URL;
const bindApiHost = process.env.REACT_APP_BIND_API_URL;

export default {
  apiHost,
  bindApiHost,
};
